import React from "react"
import { Box, Button, Fade, Grid, Typography, useTheme } from "@material-ui/core";
import { useStyles } from './tipo-pagamento-styles'
import { Carregando } from "components";
import { FormaPagamentoIcon } from "components/icons/forma-pagamento-icon";
import { EnumOpcoesDelivery } from "storage";
import { TipoPagamentoProps } from "./tipo-pagamento-props";
import { FasesHeader } from "../../../components/fases-header/fases-header";
import { TipoPagamentoErro } from "./components/tipo-pagamento-erro/tipo-pagamento-erro";
import { usePedidos } from "services/providers/pedidos-provider";
import { PagamentoIcon } from "components/icons/pagamento-icon";
import { DeliveryIcon } from "components/icons/delivery-icon";
import { MercadoIcon } from "components/icons/mercado-icon";
import { PedidoValores } from "../../../../pedido-valores/pedido-valores";
import { ComprovanteIcon } from "components/icons/comprovante-icon";
import { useDadosDeliveryStore } from "services/store/dados-delivery";

export const TipoPagamento = ({
    cardapioDados,
    empresaId,
    voltar,
    clickPix,
    clickFinalizar,
    mesaId,
    handleCancelarPedido,
    clickCredito,
    carregandoRegistrarPix,
    falha,
    msgErro,
    onClickTipoPagamento,
    onClickPagarDepois,
}: TipoPagamentoProps) => {
    const classes = useStyles()
    const theme = useTheme()
    const { selecionarTpPagamento, isPedidoDelivery } = usePedidos()
    const tipoDelivery = useDadosDeliveryStore(state => state.tipoDelivery)


    // VALORES
    const isRetirada = tipoDelivery === EnumOpcoesDelivery.Retirada

    // PAGAMNETOS
    const hasFinalizadorasCredenciadas = (cardapioDados?.finalizadoras ?? []).some(x => x.credenciado) && cardapioDados?.configuracoes.disponibilizarPagamentoFinalizacao === true

    const handleClickTipoPagamento = (tpPagamento: 'interno' | 'entrega') => {
        selecionarTpPagamento(tpPagamento)
        onClickTipoPagamento()
    }

    return (
        <Box height={"100%"} width={"100%"} className={classes.boxContainer}>
            <FasesHeader titulo="Selecionar Pagamento" voltar={voltar} />
            <Box className={classes.content}>
                <div className={classes.scrollable}>
                    {carregandoRegistrarPix
                        ? (
                            <Fade in>
                                <div>
                                    <Carregando
                                        carregando
                                        titulo="Aguarde..."
                                        mensagem={"Estamos gerando o pagamento PIX."}
                                    />
                                </div>
                            </Fade>
                        )
                        : falha ? (
                            <TipoPagamentoErro
                                msgErro={msgErro}
                                clickPix={clickPix}
                                clickFinalizar={clickFinalizar}
                                handleCancelarPedido={handleCancelarPedido}
                                tipoDelivery={tipoDelivery}
                            />
                        ) : (
                            <Fade in >
                                <Box display="flex" flexDirection="column" width='100%' height='100%' flex={1}>
                                    <Box
                                        className={classes.contentTitle}
                                        flex="1 1 auto"
                                        textAlign="center"
                                        display='flex'
                                        flexDirection="column"
                                        justifyContent="center"
                                    >
                                        <Box>
                                            <FormaPagamentoIcon
                                                tipo={
                                                    theme.palette.type === "light"
                                                        ? 'BUTTON'
                                                        : 'BUTTON_PRIMARY'
                                                }
                                                style={{
                                                    height: 50,
                                                    width: 50
                                                }} />
                                        </Box>
                                        <Box mb={3}>
                                            <Typography variant="h4" style={{
                                                fontWeight: 700
                                            }}>
                                                Pagamento
                                            </Typography>
                                        </Box>
                                        <Typography variant="body1" style={{ marginBottom: theme.spacing(3) }}>
                                            {hasFinalizadorasCredenciadas ? (
                                                "Você pode escolher entre pagar antecipadamente ou, se preferir, na maquininha."
                                            ) : (
                                                `O pagamento deste pedido será realizado no momento da ${tipoDelivery && tipoDelivery !== EnumOpcoesDelivery.Retirada ? " entrega" : "retirada"}.`
                                            )
                                            }
                                        </Typography>
                                    </Box>
                                    <Box p={1}>
                                        <Grid container className={classes.contentPayment}>
                                            <PedidoValores />
                                            {hasFinalizadorasCredenciadas && (
                                                <Grid item xs={12}>
                                                    <Button
                                                        size="large"
                                                        variant={"contained"}
                                                        fullWidth
                                                        color="primary"
                                                        onClick={() => handleClickTipoPagamento('interno')}
                                                        className={classes.espacamento}
                                                    >
                                                        <PagamentoIcon tipo="BUTTON_PRIMARY" />
                                                        Pagar Agora
                                                    </Button>
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <Button
                                                    size="large"
                                                    variant={"contained"}
                                                    fullWidth
                                                    color="primary"
                                                    onClick={() => isPedidoDelivery ? handleClickTipoPagamento('entrega') : onClickPagarDepois()}
                                                    className={classes.espacamento}
                                                >
                                                    {isPedidoDelivery ? (
                                                        <>
                                                            {isRetirada ? (
                                                                <MercadoIcon tipo={'BUTTON_PRIMARY'} />
                                                            ) : (
                                                                <DeliveryIcon tipo={'BUTTON_PRIMARY'} />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <ComprovanteIcon tipo={'BUTTON_PRIMARY'} />
                                                    )}
                                                    {isPedidoDelivery === false ? (
                                                        <>Pagar depois</>
                                                    ) : (
                                                        <>
                                                            Pagar na {isRetirada ? 'Retirada' : 'Entrega'}
                                                        </>
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            </Fade >
                        )}
                </div>
            </Box>
        </Box>
    )
}